export default "__VITE_ASSET__85fe926f__"